<script lang="ts">
  import { getContextedUrl } from '../../../common/util';
  import ProductConditionTag from '../../common/components/ProductConditionTag.svelte';
  import SponsoredTag from '../../common/components/SponsoredTag.svelte';

  export let data: any;
  export let preorder: boolean = false;
</script>

<section class="product_title {preorder ? 'preorder-title' : ''}">
  {#if data?.brandName !== null && data?.brandNameEn !== 'Default Value'}
    <div class="brand-name" style:color={data?.brandColor}>
      {#if data?.shopMoreDetails?.brand?.url}
        <a href={getContextedUrl(data?.shopMoreDetails.brand.url)}>{data?.brandName}</a>
      {:else}
        {data?.brandName}
      {/if}
      {#if data?.isSponsored}
        <SponsoredTag variant="pdp" />
      {/if}
    </div>
  {/if}
  <h2 class="product-name">
    <!-- {#if data?.marketPlaceOfferConditionCode == 'OPEN_BOX'}
      <img src="/_ui/responsive/theme-extra/images/openbox.svg" alt="openbox" class="product-condition-tag" />
    {:else if data?.marketPlaceOfferConditionCode == 'RENEWED'}
      <img src="/_ui/responsive/theme-extra/images/renewed.svg" alt="renewed" class="product-condition-tag" />
    {/if} -->
    <ProductConditionTag condition={data?.marketPlaceOfferConditionCode} />
    {data?.name}
  </h2>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .product_title {
    padding: 17px 16px 0;
    background-color: $neutral-light-04;
    @include desktop-min-width {
      padding: 0;
    }
    &.preorder-title {
      background-color: transparent;
      padding-top: 22px;
      .brand-name {
        margin-bottom: 2px;
        color: $neutral-dark-01;
        font-weight: 400;
        @include desktop-max-width {
          line-height: 20px;
        }
        a {
          color: $neutral-dark-01;
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
        }
      }
      .product-name {
        color: $neutral-dark-01;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
      }
      @include desktop-min-width {
        padding-top: 50px;
        .brand-name {
          margin-bottom: 10px;
          a {
            font-size: 16px;
            line-height: 18px;
          }
        }
        .product-name {
          font-size: 30px;
          line-height: 38px;
        }
      }
    }
  }
  .brand-name {
    color: $icon-only-icon-blue;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: baseline;
  }
  .product-name {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: $neutral-dark-01;
    margin: 2px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-transform: none;
    display: flex;
    align-items: center;
    gap: 4px;
    // -webkit-line-clamp: 2;
    :global(img) {
      display: inline-block;
      vertical-align: text-top;
      @include desktop-max-width {
        transform: translateY(-1px);
      }
    }
  }

  .product-condition-tag {
    width: 78.67px;
    height: 25.29px;
    display: inline;
  }

  @include desktop-min-width {
    .product_title {
      background-color: $primary-white;
    }
    .brand-name,
    .brand-name a {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
    .product-name {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      margin: 8px 0 0 0;
      display: inline-block;
    }
    .product-condition-tag {
      width: 81.43px;
      height: 25.94px;
    }
  }
</style>
